import Vue from 'vue'
import fun from "./fun";

export default (function () {
  Vue.filter('date', function (value) {
    var d=new Date(value*1000);
    var y=fun.two(d.getFullYear());
    var m=fun.two(d.getMonth()+1);
    var da=fun.two(d.getDate());
    return y+"-"+m+"-"+da;
  })
  Vue.filter("title",function(str){
      return str.length>15?str.substr(0,15)+"...":str;
  })
  Vue.filter("title12",function(str){
      return str.length>12?str.substr(0,12)+"...":str;
  })
  Vue.filter("strtime",function(str){
      if(!str){
          return str;
      }
      return str.length>10?str.substr(0,10):str;
  })
  Vue.filter("month",function(str){
      return str.length>7?str.substr(2,5):str;
  })








})()//--end


// WEBPACK FOOTER //
// ./src/js/filter.js